// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Asset_mobile__EulEl","desktop":"Asset_desktop__bQsh2"};